//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import pluginCard from '@/components/card/plugin-card.vue';
import mgSelect from '@/components/custom/mg-select.vue';
import mgDialog from '~/components/custom/mg-dialog.vue';
import mgButton from '~/components/custom/mg-button.vue';
import mgInput from '@/components/custom/mg-input.vue';
import contactForm from '@/components/form/contact-form.vue';
import { checkLogin } from '@/utils/sso';
import emptyUser from '@/components/empty-user.vue';
import { pluginApiUrlMap } from '@/api/url';
import subscription from '@/components/subscription/subscription.vue';
import { isElectron } from '@/utils/constants';

let ticking = false;
// 屏蔽的插件id数组
const blockedPlugins = [];
export default {
  components: {
    mgSelect,
    pluginCard,
    contactForm,
    mgDialog,
    mgButton,
    mgInput,
    emptyUser,
    subscription,
  },
  data() {
    return {
      cata_name: this.$route.query.cata_name || '全部',
      loading: false,
      page_num: 1,
      page_size: 24,
      ip: '',
      pluginList: [],
      // 经过过滤后的用来渲染的插件列表
      renderPluginList: [],
      catalogs: [],
      isSearch: false,
      searchVal: '',
      total: 0,
      swiperOption: {
        autoplay: 5000,
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
      fixed: false,
      filterTop: 0,
      filterOptions: [
        {
          value: 0,
          label: '综合排序',
        },
        {
          value: 1,
          label: '最多安装',
        },
        {
          value: 2,
          label: '最多点赞',
        },
        {
          value: 3,
          label: '最多浏览',
        },
      ],
      editorTypeOptions: [
        {
          value: 0,
          label: '全部',
        },
        {
          value: 1,
          label: '设计模式',
        },
        {
          value: 2,
          label: '研发模式',
        },
      ],
      editorTypeArray: ['all', 'canvas', 'devMode'],
      defaultChoosed: 0,
      defaultEditorType: 0,
      isShowDialog: false,
      isEmpty: false,
      showBorder: false, // 是否展示筛选框下的boder
      isClient: false,
    };
  },
  computed: {
    disabled() {
      return this.loading || this.noMore;
    },
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
    action_position() {
      return this.isSearch && this.searchVal ? 'search' : 'plugin_community';
    },
    noMore() {
      return this.total && this.pluginList.length >= this.total;
    },
    banners() {
      return this.$store.state.app?.pluginBanners || [];
    },
    isPluginPage() {
      return this.$route.path === '/plugin';
    },
  },
  watch: {},
  created() {
    this.$store.dispatch('app/getPluginBanners');
  },
  mounted() {
    this.isClient = isElectron();
    const top = this.$refs.content.offsetTop;
    this.$nextTick(() => {
      this.filterTop = top;
      const topbar = this.$store.state.app.topbar;
      const filterHeight = this.$refs.filterTool.clientHeight;
      this.filterTop = top - topbar - filterHeight;
    });
    this.loadMoreData();
    if (this.$store.state.user.userInfo?.id) {
      this.searchResource();
    }
    this.$sensors.track('page_view', {
      action_position: 'plugin_community',
    });
  },
  beforeDestroy() {
    this.clearCondition();
    window.removeEventListener('scroll', this.scrollEvent);
  },
  async asyncData({ app }) {
    app.head.title = `图标/原型设计插件,智能图表设计插件-MasterGo插件广场`;
    try {
      const params = {
        page_num: 1,
        page_size: 24,
        sort_type: 0,
        editor_type: 'canvas/devMode',
      };
      const requestUrl = pluginApiUrlMap.getPlugins;
      const resPlugins = await app.$axios.$get(requestUrl, { params });
      let pluginList = [];
      // 实际渲染的列表
      let renderPluginList = [];
      let total = 0;
      if (resPlugins.code && resPlugins.code === 'OK') {
        resPlugins?.data?.forEach((element) => {
          element.loading = false;
          element.favorite = false;
          element.is_install = false;
        });
        pluginList = resPlugins.data || [];
        renderPluginList = pluginList.filter((item) => !blockedPlugins.includes(item?.plugin_id));
        total = resPlugins.meta.page.total;
      }
      return {
        pluginList,
        renderPluginList,
        total,
        isEmpty: pluginList.length === 0,
      };
    } catch (e) {
      console.log('e---', e);
      return {};
    }
  },
  methods: {
    jumpSearch() {
      window.open(
        this.$router.resolve({
          path: '/search',
          query: {
            cata_name: '插件',
            k: this.searchVal,
          },
        }).href,
      );
      this.searchVal = '';
    },
    jumpResource() {
      this.$router.push({
        path: '/',
      });
    },
    scrollEvent() {
      const that = this;
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
          const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
          const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
          that.showBorder = scrollTop >= that.filterTop;
          const scrollTotal = scrollTop + clientHeight;
          const offsetBottom = 50;
          if (!that.noMore && !that.isEmpty && !that.loading) {
            if (scrollTotal + offsetBottom >= scrollHeight) {
              that.loadMore();
            }
          }
          ticking = false;
        });
        ticking = true;
      }
    },
    loadMoreData() {
      if (!window) {
        return;
      }
      window.addEventListener('scroll', this.scrollEvent);
    },
    changeType(cate_name) {
      this.cata_name = cate_name;
      this.clearCondition();

      const path = this.$route.path;
      const query = this.$route.query; // 这里可以用Vue的方法获取参数，也可以用正则的方法获取url中的参数
      const new_query = { ...query, cata_name: this.cata_name };
      this.$router.push({ path, query: new_query });
      this.requestPluginData();
    },
    changeFilter() {
      this.clearCondition();
      this.requestPluginData();
      this.$nextTick(() => {
        this.scrollToTop();
      });
    },
    clearCondition() {
      this.page_num = 1;
      // this.pluginList = [];
    },
    searchResource() {
      if (this.searchVal) this.isSearch = true;
      this.clearCondition();
      this.requestPluginData();
    },
    scrollToTop() {
      const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      const scroll = scrollHeight - clientHeight;
      if (this.filterTop && scroll >= 0) {
        window.scrollTo({
          top: this.filterTop <= scroll ? this.filterTop : scroll - 10,
        });
      }
    },
    loadMore() {
      if (this.noMore || this.loading) return;
      this.page_num++;
      this.requestPluginData();
    },
    // 请求插件列表
    async requestPluginData() {
      this.loading = true;
      this.isEmpty = false;
      const params = {
        page_num: this.page_num,
        page_size: this.page_size,
        sort_type: this.defaultChoosed,
      };

      const editorType = this.editorTypeArray[this.defaultEditorType];
      if (this.isPluginPage && editorType !== 'all') {
        params.editor_type = editorType;
      }

      let requestUrl = '';
      let res = null;
      try {
        requestUrl = pluginApiUrlMap.getPlugins;
        res = await this.$axios.$get(requestUrl, { params });
        const { code, data = [], meta } = res;
        if (code === 'OK') {
          this.loading = false;
          this.total = meta.page.total;
          data?.forEach((element) => {
            element.loading = false;
          });
          if (this.pluginList.length && this.page_num !== 1) {
            if (data?.length) this.pluginList.push(...data);
          } else {
            this.pluginList = data || [];
          }
          // 过滤屏蔽插件
          this.renderPluginList = this.pluginList.filter((item) => !blockedPlugins.includes(item?.plugin_id));
          if (!this.pluginList.length) {
            this.isEmpty = true;
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    bannerClick(banner, index) {
      this.$sensors.track('get_plugin', {
        action_position: 'banner',
        plugin_id: banner.plugin_id,
        action_detail: index + 1,
        plugin_name: banner.res_name,
      });
      this.$sensors.track('event_click', {
        action_position: 'community',
        action_parameter0: 'community_plugin',
        action_type: 'click',
        action_detail: `banner_${index + 1}`,
      });
    },
    contactUs() {
      const isLogin = checkLogin();
      // 联系我们
      if (isLogin) this.isShowDialog = true;
    },
    close() {
      this.isShowDialog = false;
      setTimeout(() => {
        this.$refs['contact-form']?.handleReset();
      }, 200);
    },
    submit() {
      this.$refs['contact-form']?.handleSubmit({
        fail: () => {},
        success: (data) => {
          this.$axios
            .post(pluginApiUrlMap.sendEmail, data)
            .then(() => {
              this.close();
              this.$message({
                message: '提交成功，我们会在5个工作日之内给您反馈。',
                type: 'success',
              });
            })
            .catch(() => {
              this.$message({
                message: '提交失败，请重试',
                type: 'success',
              });
            });
        },
      });
    },
    handelSubs() {
      this.$refs.subs?.addAccessNum();
    },
  },
};
